"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modificationsApiV1 = exports.modificationsApi = exports.updateModificationForTest = exports.removeModificationForTest = exports.getModificationsForTest = exports.removeModification = exports.createModification = exports.updateModification = exports.getModificationsForVariation = exports.getActionTracking = void 0;
const getActionTracking = (caller) => ({ accountId, testId }) => caller(`/api/core/reporting/accounts/${accountId}/tests/${testId}/action_trackings?filter[custom]=0&_max_per_page=0`).get();
exports.getActionTracking = getActionTracking;
const getModificationsForVariation = (caller) => ({ accountId, testId, variationId }) => {
    return caller(`/api/core/accounts/${accountId}/tests/${testId}/variations/${variationId}/modifications?_max_per_page=0`).get();
};
exports.getModificationsForVariation = getModificationsForVariation;
const updateModification = (caller) => ({ accountId, testId, modificationId, variationId, payload }) => {
    return caller(`/api/core/accounts/${accountId}/tests/${testId}/variations/${variationId}/modifications/${modificationId}`).patch(payload);
};
exports.updateModification = updateModification;
const createModification = (caller) => ({ accountId, testId, variationId, payload }) => {
    return caller(`/api/core/accounts/${accountId}/tests/${testId}/variations/${variationId}/modifications`).post(payload);
};
exports.createModification = createModification;
const removeModification = (caller) => ({ accountId, testId, variationId, modificationId }) => {
    return caller(`/api/core/accounts/${accountId}/tests/${testId}/variations/${variationId}/modifications/${modificationId}`).delete();
};
exports.removeModification = removeModification;
const getModificationsForTest = (caller) => ({ accountId, testId }) => {
    return caller(`/accounts/${accountId}/tests/${testId}/modifications`).get();
};
exports.getModificationsForTest = getModificationsForTest;
const removeModificationForTest = (caller) => ({ accountId, testId, modificationId }) => {
    return caller(`/accounts/${accountId}/tests/${testId}/modifications/${modificationId}`).delete();
};
exports.removeModificationForTest = removeModificationForTest;
const updateModificationForTest = (caller) => ({ accountId, testId, modificationId, payload }) => {
    const { value, ...restPayload } = payload;
    const resultPayload = value ? { ...payload, value: JSON.stringify(value) } : restPayload;
    return caller(`/accounts/${accountId}/tests/${testId}/modifications/${modificationId}`).patch(resultPayload);
};
exports.updateModificationForTest = updateModificationForTest;
const modificationsApi = (caller) => ({
    getActionTracking: (0, exports.getActionTracking)(caller),
    getModificationsForVariation: (0, exports.getModificationsForVariation)(caller),
    updateModification: (0, exports.updateModification)(caller),
    createModification: (0, exports.createModification)(caller),
    removeModification: (0, exports.removeModification)(caller),
});
exports.modificationsApi = modificationsApi;
const modificationsApiV1 = (caller) => ({
    getModifications: (0, exports.getModificationsForTest)(caller),
    removeModification: (0, exports.removeModificationForTest)(caller),
    updateModification: (0, exports.updateModificationForTest)(caller),
});
exports.modificationsApiV1 = modificationsApiV1;
//# sourceMappingURL=api.js.map